import { createContext, FC, PropsWithChildren, ReactNode, useContext, useState } from "react";

interface SearchContextValue {
  actions: ReactNode;
  setActions: (actions: ReactNode) => void;
  title?: string;
  setTitle: (title?: string) => void;
}

const SearchContext = createContext<SearchContextValue | undefined>(undefined);

export const SearchContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [actions, setActions] = useState<ReactNode>(null);
  const [title, setTitle] = useState<string>();

  return <SearchContext.Provider value={{ actions, setActions, title, setTitle }}>{children}</SearchContext.Provider>;
};

export const useSearchContext = (): SearchContextValue => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearchContext must be used within a SearchContextProvider");
  }
  return context;
};

export default SearchContext;
